export default __webpack_public_path__ + "static/media/about-9.f17465de.png";